export default __webpack_public_path__ + "svg/calendar/2025/3/junio.svg?5f4bb16c";